import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';

function HelpItem({ text }) {
  return <li className="text-sm text-muted-foreground">• {text}</li>;
}

function HelpCard({ title, items }) {
  return (
    <div className="border border-border rounded-lg p-4 bg-card">
      <h2 className="font-semibold text-lg mb-3 text-primary">{title}</h2>
      <ul className="space-y-2">
        {items.map((item, j) => <HelpItem key={j} text={item} />)}
      </ul>
    </div>
  );
}

export default function Help() {
  const { language } = useLanguage();
  const { user } = useAuth();
  
  if (user?.role === 'collaborateur') {
    return <div className="flex items-center justify-center h-64"><p className="text-muted-foreground">Page réservée aux managers.</p></div>;
  }
  
  const titles = { fr: "Guide d'utilisation", en: "User Guide", de: "Benutzerhandbuch" };
  const subtitles = { fr: "Documentation pour administrateurs", en: "Documentation for administrators", de: "Dokumentation für Administratoren" };
  
  const cards = language === 'en' ? [
    { title: "Schedule", items: ["Click a cell to create a slot", "Drag & drop to move", "Copy weeks", "Export PDF/Excel"] },
    { title: "Absences", items: ["View pending requests", "Approve or reject"] },
    { title: "Administration", items: ["Configure work hours", "Manage holidays", "Add users"] }
  ] : language === 'de' ? [
    { title: "Planung", items: ["Klicken zum Erstellen", "Ziehen zum Verschieben", "Wochen kopieren", "PDF/Excel Export"] },
    { title: "Abwesenheiten", items: ["Anträge anzeigen", "Genehmigen oder ablehnen"] },
    { title: "Verwaltung", items: ["Arbeitszeiten konfigurieren", "Feiertage verwalten", "Benutzer hinzufügen"] }
  ] : [
    { title: "Planning", items: ["Cliquez pour créer un créneau", "Glissez pour déplacer", "Copiez des semaines", "Export PDF/Excel"] },
    { title: "Absences", items: ["Consultez les demandes", "Approuvez ou rejetez"] },
    { title: "Communication", items: ["Envoyez des messages", "Consultez l'historique"] },
    { title: "Congés", items: ["Consultez les soldes", "Modifiez les soldes (directeur)"] },
    { title: "Administration", items: ["Heures de travail", "Jours fériés", "Utilisateurs"] }
  ];

  return (
    <div className="space-y-6" data-testid="help-page">
      <div>
        <h1 className="text-3xl font-bold">{titles[language] || titles.fr}</h1>
        <p className="text-muted-foreground">{subtitles[language] || subtitles.fr}</p>
      </div>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {cards.map((card, i) => <HelpCard key={i} title={card.title} items={card.items} />)}
      </div>
    </div>
  );
}
